import axios from 'axios'
import storage from '@/common/storage.js'
import configs from "@/configs/configs.js";
import router from '@/router/index.js' //引入路由对象
import { Message } from 'element-ui'

let pending = [] //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken
let removePending = config => {
    for (let p in pending) {
        if (pending[p].u === config.url + '&' + config.method) {
            //当当前请求在数组中存在时执行函数体
            pending[p].f() //执行取消操作
            pending.splice(p, 1) //把这条记录从数组中移除
        }
    }
}

//基地址
let instance = axios.create({
    baseURL: configs.baseURL,
    retry: 3,
    retryDelay: 1000
    // timeout: 0
})

instance.interceptors.request.use(
    config => {
        let token = storage.getToken()
        if (token) {
            config.headers.Authorization = 'bearer ' + token
        }
        // 默认版本号
        config.headers.Accept = config.headers.Accept ? `application/vnd.szlb-hams-version.V${config.headers.Accept}+json` : "application/vnd.szlb-hams-version.V1.0.0+json";

        removePending(config) //在一个ajax发送前执行一下取消操作
        config.cancelToken = new cancelToken(c => {
            // 这里的ajax标识我是用请求地址&请求方式拼接的字符串，当然你可以选择其他的一些方式
            pending.push({ u: config.url + '&' + config.method, f: c })
        })

        return config
    },
    error => {
        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    response => {
        const res = response.data
        const config = response.config

        removePending(config)
        // return res

        // testing
        // config.__retryCount = config.__retryCount || 0
        // if (config.__retryCount < config.retry) {
        //     res.error_code = 666
        // }

        if (res.error_code != 1) {
            Message({
                message: res.error_message,
                type: 'error',
                duration: 5 * 1000
            })
            // TODO：更新token并重新请求接口，约定error_code
            if (res.error_code == 666) {
                if (!config || !config.retry)
                    return Promise.reject(res.error_message)

                config.__retryCount = config.__retryCount || 0

                if (config.__retryCount >= config.retry) {
                    return Promise.reject(res.error_message)
                }

                config.__retryCount += 1

                var backoff = new Promise(function(resolve) {
                    setTimeout(function() {
                        resolve()
                    }, config.retryDelay || 1)
                })

                return backoff.then(function() {
                    return instance(config)
                })
            }
            // 根据错误码返回登录页
            if (res.error_code == 400 || res.error_code == -402) {
                storage.removeToken();
                storage.removeId();
                storage.removeName();
                router.push({
                    path: '/login'
                })
            }

            return Promise.reject(res)
        } else {
            return res.data
        }
    },
    error => {
        console.log('response err: ' + error) // for debug
        if (typeof error !== 'object') {
            Message({
                message: error,
                type: 'error',
                duration: 5 * 1000
            })
        }
        return Promise.reject(error)
    }
)
/**
 * @param path {string} path
 * @param opts {Object} options
 * @return {?Object}
 *
 * @description
 * Normalizes the given path, returning a regular expression
 * and the original path.
 *
 * Inspired by pathRexp in visionmedia/express/lib/utils.js.
 */
let pathReplace = function(path, opts) {
    let newPath = path
    const { ...obj } = opts
    if (obj == undefined || obj == null) {
        return newPath
    } else {
        let newUrl = ''
        let urlList = []
        urlList = newPath.split('/')
        for (let i = 1; i < urlList.length; i++) {
            if (urlList[i][0] == ':') {
                let str = urlList[i].slice(1)
                newUrl = newUrl + '/' + obj[str]
            } else {
                newUrl = newUrl + '/' + urlList[i]
            }
        }
        return newUrl + '?t=' + Date.parse(new Date())
    }
}

// 处理http请求
let config = function(config, params) {
    //提取接口url路径
    const { ...obj } = params
    let url = pathReplace(config.url, obj)
    return {
        // 发送请求
        request: function(obj1) {
            let { ...config1 } = config
            config1.url = url
            if (obj1) {
                if (obj1.params) {
                    config1.params = obj1.params
                } else if (obj1.data) {
                    config1.data = obj1.data
                }
            }
            //执行http接口请求
            // return instance(config1).then(successCallback, errorCallback)
            return instance(config1).then(successCallback)
        }
    }
}
// 请求成功回调
const successCallback = result => {
    return result
}

// 请求失败回调
const errorCallback = result => {
    return result
}

export default {
    config: config
}



// WEBPACK FOOTER //
// ./src/models/axios_instance.js